const isUndefined = value => value === undefined

export default isUndefined
